module.exports = __webpack_public_path__ + "static/Kameros-166605b4b899cafc7bcc1ff54b461629.png";